import LoadingWrapper from 'components/LoadingWrapper'

import ConfidenceConfig from './ConfidenceConfig'
import TabContent from './TabContent'

const DisplayConfig = () => {
  const readerHelpIconProps = {
    builderPath: '/builder/ja-JP/ocr-reader-doc/accuracy-settings.html#Accuracy',
    concurPath: '/concur/ja-JP/ocr-reader-doc/accuracy-settings.html#Accuracy',
    invoicePath: '/invoice/ja-JP/ocr-reader-doc/accuracy-settings.html#Accuracy',
    orderFormPath: '/order-form/ja-JP/ocr-reader-doc/accuracy-settings.html#Accuracy',
  }

  return (
    <TabContent
      padding
      title="精度区分"
      readerHelpIconProps={readerHelpIconProps}
      description="認識精度の評価値を設定します。"
    >
      <LoadingWrapper loaded>
        <ConfidenceConfig />
      </LoadingWrapper>
    </TabContent>
  )
}

export default DisplayConfig
